import { convertToMinutes } from '@app/utils/time.utils';
export const mapBookingItemInput = (input) => {
    const updatedInput = Object.assign(Object.assign({}, input), { conditionFieldId: isNaN(+input.conditionFieldId) ? null : +input.conditionFieldId, whatsappTemplateId: isNaN(+input.whatsappTemplateId) ? null : +input.whatsappTemplateId, deadlineReferenceId: +input.deadlineReferenceId, deadline: convertToMinutes(+input.deadlineHours, +input.deadlineMinutes), shouldTriggerBeforeDeadlineReference: !!parseInt(input.shouldTriggerBeforeDeadlineReference) });
    delete updatedInput.deadlineHours;
    delete updatedInput.deadlineMinutes;
    return updatedInput;
};
